export default class ModelsManager {

  static getBestFinalPrice = (data) => {
    return data && data.best_final_price ?
      data.best_final_price : '';
  };

  static getBestFinalPriceFormat = (data) => {
    return data && data.best_final_price_format ?
      data.best_final_price_format : '';
  };

  static getBestPrice = (data) => {
    return data && data.best_price ?
      data.best_price : '';
  };

  static getBestPriceFormat = (data) => {
    return data && data.best_price_format ?
      data.best_price_format : '';
  };

  static getDescription = (data) => {
    return data && data.description ?
      data.description : '';
  };

  static getId = (data) => {
    return data && data.id ?
      data.id: '';
  };

  static getImage = (data) => {
    return data && data.image ?
      data.image: '';
  };

  static getVehiclesCount = (data) => {
    return data && data.vehicles_count ?
      data.vehicles_count: 0;
  };

  static getBestCuotaPrice = (data) => {
    return data && data.best_cuota_price ?
      data.best_cuota_price : ""
  };

  static getImageAlt = data => data?.image_alt || '';

  static getBestCuotaPriceFormat = (data) => {
    return data && data.best_cuota_price_format ?
      data.best_cuota_price_format : ""
  };

  static getUrlKey = (data) => {
    return data && data.url_key ? data.url_key : "";
  };

  static getBackgroundColor= (data) => {
    return data && data.background_color ? data.background_color : "";
  };

  static geCustomBgColor = (data) => {
    return data && data.custom_bg_color ? data.custom_bg_color : "";
  };

  static getTags = (data) => {
    return data && data.tags ? data.tags : [];
  };

  static getBackgroundHexColor = (data) => {
    return data && data.background_hex_color ? data.background_hex_color : "";
  };

  static getTagText = (data) => {
    return data && data.tag_text ? data.tag_text : "";
  };

  static getTextHexColor = (data) => {
    return data && data.text_hex_color ? data.text_hex_color : "";
  };
}
